import styled from 'styled-components';

export const Contents = styled.div`
  grid-area: contents;
  ${(p) => p.theme.typography.body1}
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;
